module.exports = __webpack_public_path__ + "img/newinsta.5a073e93.svg";